export const StepIds = {
  Step1: 'Step1',
  Step2: 'Step2',
};

export type StepId = keyof typeof StepIds;
